module.exports = __webpack_public_path__ + "img/yw.0c9c4765.png";